module.exports = __webpack_public_path__ + "img/示意-首页.585f0605.png";